/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_R2_DescriptionInputs */

const en_admin_settings_groups_r2_description = /** @type {(inputs: Admin_Settings_Groups_R2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object storage settings`)
};

const zh_admin_settings_groups_r2_description = /** @type {(inputs: Admin_Settings_Groups_R2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对象存储设置`)
};

/**
* | output |
* | --- |
* | "Object storage settings" |
*
* @param {Admin_Settings_Groups_R2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_r2_description = /** @type {((inputs?: Admin_Settings_Groups_R2_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_R2_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_r2_description(inputs)
	return zh_admin_settings_groups_r2_description(inputs)
});
export { admin_settings_groups_r2_description as "admin.settings.groups.r2.description" }